import languageModel from '../models/language.model';

String.prototype.toLocal = function (txt) {
  return languageModel.getText(this, txt);
}

Array.prototype.getByCode = function (code) {
  var obj = this.find(e => e.code === code);
  return obj;
}

Array.prototype.getIndexByCode = function (code) {
  var obj = this.getByCode(code);
  var idx = this.indexOf(obj);
  return idx;
}

Array.prototype.getIndex = function (obj) {
  var idx = this.indexOf(obj);
  return idx;
}

Array.prototype.removeByCode = function (code) {
  var obj = this.getByCode(code);
  var idx = this.indexOf(obj);
  this.splice(idx, 1);
}

Array.prototype.remove = function (obj) {
  var idx = this.indexOf(obj);
  this.splice(idx, 1);
}

Array.prototype.codeExists = function (code) {
  var exists = (this.getByCode(code))
  return exists;
}

Array.prototype.removeDuplicateCode = function () {
  let uniqueArr = [];
  this.forEach((c) => {
    if (!uniqueArr.codeExists(c.code)) {
      uniqueArr.push(c);
    }
  });

  return uniqueArr;
}

Array.prototype.removeDuplicate = function () {
  let uniqueArr = [...new Set(this)];
  return uniqueArr;
}

Array.prototype.removeListByCode = function (arrList) {
  arrList.forEach(s => {
    this.removeByCode(this, s.code);
  });
}

Array.prototype.addList = function (arrList) {
  this.splice(0, 0, ...arrList); // INSERT 
}

Array.prototype.filterRemoveListByCode = function (arrList) {
  let result = this.filter(e => !arrList.find(a => a.code === e.code));
  return result;
}

Array.prototype.filterIncludeListByCode = function (arrList) {
  let result = this.filter(e => arrList.find(a => a.code === e.code));
  return result;
}
